import {CheckInFormValues, validateRequiredContainerNumber, validateRequiredSealNumber, validateRequiredDriverFirstName, validateRequiredDriverLastName, validateRequiredDriverLicenseNumber, validateRequiredAssetSize, validateRequiredChassisNumber, validateOptionalScacCode} from '../../util/check-in-field-validation';

/**
 * Validates the default fields for Loaded Container check-in.
 * Covers: CONTAINER_LOADED, TRUCK_CONTAINER_LOADED.
 * Required: containerNumber, sealNumber, driverFirstName, driverLastName,
 *           driverLicenseNumber, assetSize, chassisNumber.
 */
export const validateLoadedContainerForm = (values: CheckInFormValues): string | undefined =>
  validateRequiredContainerNumber(values.containerNumber) ??
  validateRequiredSealNumber(values.sealNumber) ??
  validateRequiredDriverFirstName(values.driverFirstName) ??
  validateRequiredDriverLastName(values.driverLastName) ??
  validateRequiredDriverLicenseNumber(values.driverLicenseNumber) ??
  validateRequiredAssetSize(values.assetSize) ??
  validateRequiredChassisNumber(values.chassisNumber) ??
  validateOptionalScacCode(values.scacCode);
